import { FinancialObligationsStoreService } from '@hb/modules/financial-obligations/financial-obligations-store.service';
import { FinancialObligationOption } from '@hb/domain/steps/financial-obligation';
import { FinancialObligationsSummaryComponent } from '@hb/modules/financial-obligations/financial-obligations-summary/financial-obligations-summary.component';
import { PartnerAlimonyComponent } from '@hb/modules/financial-obligations/partner-alimony/partner-alimony.component';
import { PersonalLoanComponent } from '@hb/modules/financial-obligations/personal-loan/personal-loan.component';
import { PrivateLeaseComponent } from '@hb/modules/financial-obligations/private-lease/private-lease.component';
import { CreditCardComponent } from '@hb/modules/financial-obligations/credit-card/credit-card.component';
import { OpenEndedCreditComponent } from '@hb/modules/financial-obligations/open-ended-credit/open-ended-credit.component';
import { MobilePhonePaymentComponent } from '@hb/modules/financial-obligations/mobile-phone-payment/mobile-phone-payment.component';
import { PaymentAccountOverdraftComponent } from '@hb/modules/financial-obligations/payment-account-overdraft/payment-account-overdraft.component';
import { StudentDebtComponent } from '@hb/modules/financial-obligations/student-debt/student-debt.component';
import { FinancialObligationsOptionsComponent } from '@hb/modules/financial-obligations/financial-obligations-options/financial-obligations-options.component';
import content from '@hb/hypotheken-berekening.content.json';

import { Component, inject, OnInit } from '@angular/core';

import { ApContentService } from '@ap/content';

@Component({
    selector: 'financial-obligations',
    imports: [
        FinancialObligationsSummaryComponent,
        PartnerAlimonyComponent,
        PersonalLoanComponent,
        PrivateLeaseComponent,
        CreditCardComponent,
        OpenEndedCreditComponent,
        MobilePhonePaymentComponent,
        PaymentAccountOverdraftComponent,
        StudentDebtComponent,
        FinancialObligationsOptionsComponent
    ],
    templateUrl: './financial-obligations.component.html'
})
export class FinancialObligationsComponent implements OnInit {
    protected readonly financialObligationsStore = inject(FinancialObligationsStoreService);
    protected readonly contentService = inject(ApContentService);
    protected readonly financialObligationOption = FinancialObligationOption;
    activeOption: FinancialObligationOption;

    ngOnInit(): void {
        this.contentService.addContentItems(content);
        this.financialObligationsStore.getActiveOption().subscribe((question) => (this.activeOption = question));
    }
}
